import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import * as fromKiosk from './kiosk/kiosk.reducer';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('kiosk', fromKiosk.reducer)],
})
export class SharedKioskDataAccessModule {}
